import { FormatHelper } from '@adp-wfn/mdf-core';
import { MDFCircleIcon } from './MDFCirlceIcon';
import { SdfIcon } from '@waypoint/react-components';
import { MDFIcon } from './MDFIcon';
import React from 'react';

export interface IStatusIcon {
  // ClassName to be applied for the icon
  className: string;
  // Size of the statusIcon
  size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg';
  // aria-label for accessibility
  ariaLabel?: string;
  // Choose one of the statusType.
  statusType?: 'success' | 'info' | 'warning' | 'error' | 'delegate' | 'notStarted' | 'inProgress' | 'submitted' | 'inReview' | 'approved' | 'accepted' | 'completed' | 'inComplete' | 'archived' | 'generalLiability' | 'default';
}

// Added  default labels if no aria-labels are passed.
const defaultStatusLabelMapper = () => {
  return {
    warning: FormatHelper.formatMessage('@@Warning'),
    inComplete: FormatHelper.formatMessage('@@Incomplete'),
    notStarted: FormatHelper.formatMessage('@@lb_not_started'),
    inProgress: FormatHelper.formatMessage('@@lbl_in_progress'),
    submitted: FormatHelper.formatMessage('@@lb_submitted'),
    inReview: FormatHelper.formatMessage('@@TD_LB_IN_REVIEW'),
    error: FormatHelper.formatMessage('@@Error'),
    archived: FormatHelper.formatMessage('@@label_ei9_status_archived'),
    success: FormatHelper.formatMessage('@@Success'),
    approved: FormatHelper.formatMessage('@@Approved'),
    accepted: FormatHelper.formatMessage('@@ROE_DASHBOARD_ACCEPTED'),
    completed: FormatHelper.formatMessage('@@label_completed'),
    info: FormatHelper.formatMessage('@@ERP_INFO_LABEL'),
    delegate: FormatHelper.formatMessage('@@label_newhirerefresh_delegatelabel'),
    generalLiability: FormatHelper.formatMessage('@@LIABILITY'),
    default: ''
  };
};

// should we take this statusType or leave it to the application developer to render it as a component?
const renderStatusIcon = (statusType) => {
  let iconDetails: { icon: string } = null;

  switch (statusType) {
    case 'warning':
    case 'inComplete':
      iconDetails = {
        icon: 'fa-exclamation'
      };
      break;

    case 'notStarted':
    case 'inProgress':
      iconDetails = {
        icon: 'fa-clock-o'
      };
      break;

    case 'submitted':
      iconDetails = {
        icon: 'fa-paper-plane'
      };
      break;

    case 'inReview':
      iconDetails = {
        icon: 'icon-clocked-in'
      };
      break;

    case 'error':
      iconDetails = {
        icon: 'fa-exclamation'
      };
      break;

    case 'archived':
      iconDetails = {
        icon: 'fa-archive'
      };
      break;

    case 'success':
    case 'approved':
    case 'accepted':
    case 'completed':
      iconDetails = {
        icon: 'fa-check'
      };
      break;

    case 'info':
      iconDetails = {
        icon: 'fa-info'
      };
      break;

    case 'delegate':
      iconDetails = {
        icon: 'fa-share'
      };
      break;

    case 'generalLiability':
      iconDetails = {
        icon: 'general-liability'
      };
      break;

    case 'default':
      iconDetails = {
        icon: ''
      };
      break;
  }

  return iconDetails;
};

export const StatusIcon = (props: IStatusIcon) => {
  const statusType = props.statusType ?? 'default';
  const statusIcon = renderStatusIcon(statusType)?.icon;
  const faStatusIcon = `fa ${statusIcon}`;
  const statusLabel = props.ariaLabel ?? defaultStatusLabelMapper()[statusType];

  // TODO: Once the UX confirms the selectable card can follow the vdl standard for the colorcode need to add this - `vdl-alert--${statusType ?? ''
  const renderIcon = (
    <MDFCircleIcon size={props.size} className={`${props.className ?? ''} mdf-status--${statusType ?? ''}`}>
      {statusIcon && (props?.statusType === 'generalLiability' ? (<SdfIcon icon="general-liability" iconTitle={statusLabel} />) : (<MDFIcon className={statusType === 'inReview' ? statusIcon : faStatusIcon} ariaLabel={statusLabel}></MDFIcon>))}
    </MDFCircleIcon>
  );

  return statusType ? renderIcon : null;
};
